export default __webpack_public_path__ + "static/media/4217.aa578bfd.png";